export default function getClientId(windowObj: Window): string {
    let clientId: string = null;
    if (windowObj.genericDiagnostics) {
        clientId = windowObj.genericDiagnostics.cId;
    }

    return clientId;
}
